// Étiquettes possibles devant l'identifiant. `pzi_id`, `PZIID :`, `Zone-Id=`, ...
const LABEL_PREFIX_REGEX =
  /^(?:pzi[\s_-]*id|pziid|pzi|zone[\s_-]*id|zoneid|bin[\s_-]*id|binid|codebin|code)\s*[:=#-]?\s*/i;

// Caractères de contrôle ajoutés par les lecteurs clavier-wedge.
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS_REGEX = /[\u0000-\u001f\u007f]+/g;

const DIGITS_ONLY_REGEX = /^[0-9]+$/;

/**
 * Extrait un identifiant d'un payload JSON.
 *
 * Un JSON incomplet ou malformé n'est pas une erreur : le champ de saisie
 * appelle le parseur à chaque frappe, donc un payload tapé caractère par
 * caractère est syntaxiquement invalide jusqu'à sa dernière accolade.
 *
 * @param {string} input payload brut
 * @returns {{ value: string } | null} valeur trouvée, ou null si ce n'est pas
 *          un objet JSON exploitable
 */
const extractFromJson = (input) => {
  if (!input.startsWith("{") && !input.startsWith("[")) {
    return null;
  }

  let parsed;
  try {
    parsed = JSON.parse(input);
  } catch (error) {
    return null;
  }

  if (parsed === null || typeof parsed !== "object") {
    return null;
  }

  const candidate = Array.isArray(parsed) ? parsed[0] : parsed;
  if (candidate === null || typeof candidate !== "object") {
    return null;
  }

  const keys = ["pzi_id", "pziId", "pziid", "zone_id", "zoneId", "codebin", "code"];
  for (const key of keys) {
    const value = candidate[key];
    if (value !== undefined && value !== null && value !== "") {
      return { value: value.toString() };
    }
  }

  return null;
};

// Les identifiants de la console tiennent sur 6 chiffres.
const MAX_DIGITS = 6;

export const parseScannedCode = (raw, options = {}) => {
  const minDigits = options.minDigits || 1;

  if (raw === undefined || raw === null) {
    return null;
  }

  let input = raw.toString().replace(CONTROL_CHARS_REGEX, " ").trim();
  if (!input) {
    return null;
  }

  const fromJson = extractFromJson(input);
  if (fromJson) {
    input = fromJson.value.replace(CONTROL_CHARS_REGEX, " ").trim();
  }

  // Un préfixe explicite signale une étiquette de l'ancienne génération, dont
  // certaines portent un 7e chiffre de contrôle « 2 » à retirer.
  const hasLabelPrefix = LABEL_PREFIX_REGEX.test(input);
  if (hasLabelPrefix) {
    input = input.replace(LABEL_PREFIX_REGEX, "").trim();
  }

  // Espaces internes possibles quand le payload a été recopié à la main.
  input = input.replace(/\s+/g, "");

  if (!DIGITS_ONLY_REGEX.test(input)) {
    return null;
  }

  let code = input;
  if (hasLabelPrefix && code.length === 7 && code.endsWith("2")) {
    code = code.slice(0, 6);
  }

  if (code.length > MAX_DIGITS || code.length < minDigits) {
    return null;
  }

  const id = parseInt(code, 10);
  return Number.isNaN(id) || id <= 0 ? null : id;
};

export default parseScannedCode;
